import {
  SESSION_REQUEST,
  SIGNIN_FAIL,
  SIGNIN_REQUEST,
  SIGNIN_SUCCESS,
  SIGNOUT_FAIL,
  SIGNOUT_REQUEST,
  SIGNOUT_SUCCESS,
} from "../../Constants/AuthConstants";

const initialStateAdmin = {
  loading_change_password: false,
  status_change_password: false,
  user_login_data: null,
  login_loading: false,
  login_status: null,
  session_loading: true,
  logout_status: false,
  error_change_password: null,
};

export const UserLoginData = (state = initialStateAdmin, action: any) => {
  try {
    if (action.type === SESSION_REQUEST) {
      return {
        ...state,
        session_loading: true,
      };
    }
    if (action.type === SIGNIN_REQUEST) {
      return {
        ...state,
        login_loading: true,
      };
    }

    if (action.type === SIGNIN_SUCCESS) {
      return {
        ...state,
        login_status: true,
        login_loading: false,
        session_loading: false,
        user_login_data: action.data,
      };
    }
    if (action.type === SIGNIN_FAIL) {
      return {
        ...state,
        login_status: false,
        login_loading: false,
        session_loading: false,
        user_login_data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const UserLogoutReducer = (state = initialStateAdmin, action: any) => {
  try {
    if (action.type === SIGNOUT_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }
    if (action.type === SIGNOUT_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === SIGNOUT_FAIL) {
      localStorage.clear();
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};
